import { registerQuery, useQuery } from 'academy-common-lib/utils/DataFetchingClient';
import quickFetch from '../../utils/quickFetch';
import Raven from 'raven-js';
export const GET_PUBLIC_LESSON = registerQuery({
  fieldName: 'publicLesson',
  args: ['pagePath', 'language'],
  fetcher({
    pagePath,
    language
  }) {
    return quickFetch(`/academy-catalog-public/v1/lessons/${language}/${pagePath}`);
  }
});
export const usePublicLesson = (pagePath, language) => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_PUBLIC_LESSON, {
    variables: {
      pagePath,
      language
    },
    onError(e) {
      Raven.captureException(e);
    }
  });
  return {
    publicLesson: data,
    publicLessonLoading: loading,
    publicLessonError: error
  };
};